import {palette} from './palette';

export const typography = {
    h1: {
        color: palette.text.primary,
        fontWeight: 500,
        fontSize: '30px',
        letterSpacing: '-0.24px',
        lineHeight: '40px',
    },
    h2: {
        color: palette.text.primary,
        fontWeight: 500,
        fontSize: '25px',
        letterSpacing: '-0.24px',
        lineHeight: '32px',
    },
    h3: {
        color: palette.text.primary,
        fontWeight: 600,
        fontSize: '16px',
        letterSpacing: '0.32px',
        lineHeight: '20px',
        fontStyle: 'normal',
    },
    h4: {
        color: palette.text.primary,
        fontSize: '24px',
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: '28px',
        letterSpacing: '-0.36px',
    },
    h5: {
        color: palette.text.primary,
        fontWeight: 500,
        fontSize: '18px',
        letterSpacing: '-0.05px',
        lineHeight: '22px',
    },
    h6: {
        color: palette.text.primary,
        fontWeight: 400,
        fontSize: '16px',
        letterSpacing: '0.32px',
        lineHeight: '20px',
        fontStyle: 'normal',
    },
    subtitle1: {
        color: palette.text.primary,
        fontSize: '14px',
        letterSpacing: '-0.05px',
        lineHeight: '25px',
    },
    subtitle2: {
        color: palette.text.secondary,
        fontWeight: 400,
        fontSize: '13px',
        letterSpacing: '-0.05px',
        lineHeight: '21px',
    },
    body1: {
        color: palette.text.primary,
        fontSize: '14px',
        letterSpacing: '-0.05px',
        lineHeight: '19px',
    },
    body2: {
        color: palette.text.secondary,
        fontSize: '12px',
        letterSpacing: '-0.04px',
        lineHeight: '16px',
    },
    button: {
        color: palette.text.primary,
        fontSize: '14px',
    },
    caption: {
        color: palette.text.secondary,
        fontSize: '11px',
        letterSpacing: '0.33px',
        lineHeight: '13px',
    },
    overline: {
        color: palette.text.secondary,
        fontSize: '11px',
        fontWeight: 500,
        letterSpacing: '0.33px',
        lineHeight: '13px',
        textTransform: 'uppercase',
    },
};
